import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-tiles',
  templateUrl: './icon-tiles.component.html',
  styleUrls: ['./icon-tiles.component.scss']
})
export class IconTilesComponent implements OnInit {

  @Input() cssClass = 'icon--18';

  constructor() { }

  ngOnInit() {
  }

}
